import { render, staticRenderFns } from "./TipoComboPorTamanho.vue?vue&type=template&id=19b7fceb&scoped=true&"
import script from "./TipoComboPorTamanho.vue?vue&type=script&lang=js&"
export * from "./TipoComboPorTamanho.vue?vue&type=script&lang=js&"
import style0 from "./TipoComboPorTamanho.vue?vue&type=style&index=0&id=19b7fceb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b7fceb",
  null
  
)

export default component.exports